module.exports = __webpack_public_path__ + "img/how-icon-1-signup.61f4cc26.png";